import React from "react";
import { Edit, SimpleForm } from "react-admin";

import { SaveWithCancelToolbar } from "../../../components/toolbars/SaveWithCancelToolbar";
import { TerminalSettingPerDateForm } from "../forms/TerminalSettingPerDateForm";

export const TerminalSettingPerDateEdit = (props) => (
	<Edit {...props} undoable={false}>
		<SimpleForm
			submitOnEnter={false}
			toolbar={<SaveWithCancelToolbar />}
		>
			<TerminalSettingPerDateForm />
		</SimpleForm>
	</Edit>
);
